import { httpClient } from '@/modules/common/services/http/http-client';
import { ICustomerBankAccountResponse } from './types';

const http = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_URL}`
});

export function getCustomerBankAccount(): Promise<ICustomerBankAccountResponse> {
  return http.get('/banking/v1/cash/getCustomerBankAccount');
}

export function getNewCustomerBankAccount(): Promise<ICustomerBankAccountResponse> {
  return http.get('/transactions/v1/deposit/bank-account');
}
